import { render, staticRenderFns } from "./WaveformTimeline.vue?vue&type=template&id=8a024ed0&scoped=true&"
import script from "./WaveformTimeline.vue?vue&type=script&lang=js&"
export * from "./WaveformTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a024ed0",
  null
  
)

export default component.exports